import React, { useEffect, useRef, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import LaddaButton from "../buttons/laddaButton";

export const resolveImagePreviewSource = (value) => {
  if (!value || typeof value !== "string") return null;
  const path = value.replace(/\\/g, "/");
  if (/^(blob:|data:image\/|https?:\/\/)/i.test(path)) return path;
  // Screens already prefix saved paths with the API base. With a relative base ("/api", as in the
  // Docker setup) that prefix is not an absolute URL, so it must not be added a second time.
  const apiUrl = process.env.REACT_APP_API_URL || "";
  if (apiUrl && path.startsWith(`${apiUrl.replace(/\/+$/, "")}/`)) return path;
  return `${apiUrl}/${path.replace(/^\/+/, "")}`;
};

const ImagePreview = ({ source, busy = false, disabled = false, onSelect, height = 280 }) => {
  const imageRef = useRef(null);
  const [failed, setFailed] = useState(false);
  const [loading, setLoading] = useState(!!source);
  useEffect(() => {
    setFailed(false);
    setLoading(!!source && !imageRef.current?.complete);
  }, [source]);
  const isLoading = busy || loading;
  const placeholder = <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
    <ImageOutlinedIcon sx={{ fontSize: 56, color: "text.disabled" }} />
    <Typography color="text.secondary">{failed ? "Imagen no disponible" : "Sin imagen seleccionada"}</Typography>
  </Box>;
  return <Box sx={{ mt: 1, height, borderRadius: 2, bgcolor: "#f5f5f5", position: "relative", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden" }}>
    {source && !failed ? <img ref={imageRef} src={source} alt="Evidencia"
      onLoad={() => setLoading(false)} onError={() => { setLoading(false); setFailed(true); }}
      style={{ width: "100%", height, objectFit: "contain", visibility: isLoading ? "hidden" : "visible" }} />
      : onSelect ? <LaddaButton type="button" width="100%" height={height} margin="0" borderRadius="8px"
        backgroundColor="#f5f5f5" borderColor="#f5f5f5" color="#757575"
        disabled={disabled || isLoading} loading={false} onClick={onSelect} aria-label="Seleccionar imagen de evidencia"
        sx={{ "&.Mui-disabled": { backgroundColor: "#f5f5f5" } }}>{placeholder}</LaddaButton> : placeholder}
    {isLoading && <Box role="status" aria-label="Cargando imagen" sx={{ position: "absolute", inset: 0, bgcolor: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <CircularProgress size={22} />
    </Box>}
  </Box>;
};

export default ImagePreview;
